export default {
  props: {
    searchResult: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      itemLists: {
        articles: (this.searchResult.results && this.searchResult.results.articles) || [],
        recipes: (this.searchResult.results && this.searchResult.results.recipes) || [],
        recipeCollections: (this.searchResult.results && this.searchResult.results.recipeCollections) || [],
      },
      itemStats: {
        articles: this.searchResult.stats && this.searchResult.stats.articles && this.searchResult.stats.articles.totalHits,
        recipes: this.searchResult.stats && this.searchResult.stats.recipes && this.searchResult.stats.recipes.totalHits,
        recipeCollections: this.searchResult.stats && this.searchResult.stats.recipeCollections && this.searchResult.stats.recipeCollections.totalHits,
      },
      moreApiUrls: {
        articles: this.searchResult.moreLinks && this.searchResult.moreLinks.articles,
        recipes: this.searchResult.moreLinks && this.searchResult.moreLinks.recipes,
        recipeCollections: this.searchResult.moreLinks && this.searchResult.moreLinks.recipeCollections
      }
    }
  },
  methods: {
    /* showMoreAddToList
     * Adds fetched data to existing list, sets focus on first new item and updates show more api link
     * Is made to use with components using base-block-epi and block-grid (like in categoryPage and entrancePage)
     *
     * @type: name of type ie "articles" or "recipes"
     * @data: data from api (show more component)
     *   { results: [ {} ] }*/
    showMoreAddToList (type, data, keyboard) {
      // Fetch data of first prop (should never be more than one in this api..)
      const result = data.results && data.results[Object.keys(data.results)[0]]
      const moreLink = data.moreLinks && data.moreLinks[Object.keys(data.moreLinks)[0]]

      // Push result to the existing array, ie this.itemLists.articles = list.result
      if (result) {
        this.itemLists[type].push(...result)
      }

      // Updated show more url, ie this.moreApiUrls.articles = list.moreLink
      this.moreApiUrls[type] = moreLink

      if (keyboard) {
        this.setFocus(type, result)
      }
    },
    setFocus (type, result) {
      // Set focus on first "new" element in the show more list if keyboard click (accessibility)
      this.$nextTick(() => {
        if (!this.$refs[type]) {
          console.warn('Glöm inte att lägga till referens på alla sektioner där showmore används, t ex ref="' + type + '". Annars får du felet under.')
        }
        const component = this.$refs[type] // ie ref="articles"
        let el = component.querySelector(`.block-grid > div > div:nth-last-of-type(${result.length}) .base-block-epi__content a`)
        // fix if component is from molecules 
        if(!el) { el = component.querySelector(`.block-grid > div > div:nth-last-of-type(${result.length}) .base-block-tmp__content a`) }

        if (el) {
          el.focus()
        } else {
          throw new Error('Det gick inte att sätta fokus i första nya elementet')
        }
      })
    }
  }
}
